<template>
  <div class="container-fluid">
    <hr class="border-muted">
    <div
      class="cursor-pointer d-flex justify-content-between align-items-center"
      @mouseover="hover = true"
      @mouseout="hover = false"
      @click.stop.prevent="onClick"
    >
      <font-awesome-icon
        v-if="selectable"
        class="mr-3"
        :icon="['far', checked.includes(value) ? 'check-square' : 'square']"
      />

      <Avatar
        :rounded="true"
        :size="40"
        :img="profilePicture"
        :username="`${firstName} ${lastName}`"
      />
    </div>
    <div class="ml-2 w-100 d-flex align-items-center">
      <div class="d-inline client-title">
        {{ firstName }} {{ lastName }}
      </div>
      <div class="d-inline ml-3">
        <small>{{ email }}</small>
      </div>

      <div
        v-if="products.length > 0"
        class="ml-auto mr-0 d-block"
      >
        <img
          v-for="product in products"
          :key="product.pk"
          class="mx-2"
          :src="product.thumb"
          :title="product.title"
          alt
          width="30"
        >
      </div>
      <font-awesome-icon
        v-if="hover && actions"
        icon="ellipsis-v"
        class="ml-auto"
        @click.prevent.stop
      />
      <div
        v-if="removable"
        :id="`client_tooltip_${email}`"
        class="ml-auto remove-icon"
        :style="`opacity: ${hover ? '1' : '0'}`"
        @click.stop="$emit('remove-clicked', email)"
      >
        <font-awesome-icon
          icon="times"
        />
      </div>
      <b-tooltip
        :target="`client_tooltip_${email}`"
        triggers="hover"
      >
        Remove from this group
      </b-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClientTableCell',
  model: {
    prop: 'checked',
    event: 'input',
  },
  props: {
    selectable: {
      type: Boolean,
      default: false,
    },
    actions: {
      type: Boolean,
      default: false,
    },
    checked: {},
    value: {},
    firstName: { default: '' },
    lastName: { default: '' },
    profilePicture: { default: '' },
    email: { default: '' },
    products: {
      type: Array,
      default() {
        return [];
      },
    },
    removable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      innerModel: [],
      hover: false,
    };
  },
  methods: {
    onClick() {
      this.$emit('click', this);
    },
    select() {
      if (this.checked.includes(this.value)) {
        this.checked.splice(this.checked.indexOf(this.value), 1);
        console.log('Removing', this.value);
      } else {
        console.log('Adding', this.value);
        this.checked.push(this.value);
      }
      console.log(this.checked);
    },
  },
};
</script>

<style scoped>
.remove-icon{
    padding: 10px;
    line-height: 0px;
    background-color: #00000000;
    border-radius: 2px;
    z-index: 9999;
    transition: background-color .3s ease;
    transition: opacity .2s ease;
}
.remove-icon:hover{

    background-color: #00000022;
}
</style>
